import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./circle.css.ts.vanilla.css-mistica.js";
var r = "_1wpwyyp1 _1y2v1nfhk _1y2v1nfhz _1y2v1nfht _1y2v1nfk3";
export { r as circle };
